export default [{
    id: 0,
    label: '推荐更新'
}, {
    id: 1,
    label: '强制更新'
}];



// WEBPACK FOOTER //
// ./src/service/constant/forceUpdatesTypes.js